import { AfterViewInit, Directive, Optional } from "@angular/core";
import { NgControl } from "@angular/forms";
import { MatLegacyInput as MatInput } from "@angular/material/legacy-input";
import { Logger } from "@dtm-frontend/shared/utils";

// eslint-disable-next-line @angular-eslint/directive-selector
@Directive({ selector: "[matInput]" })
export class AutoInputIdDirective implements AfterViewInit {
    constructor(@Optional() private input: MatInput, @Optional() private inputControl?: NgControl) {}

    public ngAfterViewInit() {
        if (!this.input) {
            Logger.captureException(new Error("Missing input provider for AutoInputIdDirective"));

            return;
        }

        const isCustomId = !this.input.id.startsWith("mat-input-");
        const controlName = this.getControlName();

        if (!isCustomId && controlName) {
            this.input.id = `auto_${controlName}`;
        }
    }

    private getControlName(): string | undefined {
        const inputControl = this.inputControl?.control;

        for (const [controlName, control] of Object.entries(inputControl?.parent?.controls ?? {})) {
            if (control === inputControl) {
                return controlName;
            }
        }

        return undefined;
    }
}
